export default {
  'pages.workbench.defaultUser': '伙伴',
  'pages.workbench.enterpriseWorkspace': '企业工作空间',
  'pages.workbench.welcome': '欢迎回来，{name}',
  'pages.workbench.welcomeDescription':
    '连接应用、基础服务与运维，从这里开始今天的工作。',
  'pages.workbench.refresh': '刷新工作台',
  'pages.workbench.openAppCenter': '进入应用',
  'pages.workbench.partialError': '部分数据暂时无法加载，已显示可用内容。',
  'pages.workbench.retry': '重新加载',
  'pages.workbench.overview': '工作空间概览',
  'pages.workbench.installedApps': '已开通应用',
  'pages.workbench.availableToTeam': '企业已开通的业务应用',
  'pages.workbench.myApps': '我的应用',
  'pages.workbench.myAppsDescription': '企业已开通的应用，随时开始工作',
  'pages.workbench.viewAll': '查看全部',
  'pages.workbench.enabled': '已开通',
  'pages.workbench.openApp': '打开 {name}（新窗口）',
  'pages.workbench.viewApp': '查看 {name}',
  'pages.workbench.noApps': '开启你的第一个企业应用',
  'pages.workbench.noAppsDescription':
    '从应用市场发现适合团队的工具，让业务协作更简单。',
  'pages.workbench.appsError': '应用列表暂时不可用',
  'pages.workbench.retryDescription': '请重新加载，或进入对应中心查看。',
  'pages.workbench.browseMarket': '浏览应用市场',
  'pages.workbench.resourceOverview': '资源概览',
  'pages.workbench.resourceOverviewDescription': '当前工作空间的集群资源用量',
  'pages.workbench.cpu': 'CPU',
  'pages.workbench.memory': '内存',
  'pages.workbench.cores': '核',
  'pages.workbench.gib': 'GiB',
  'pages.workbench.notConnected': '尚未接入',
  'pages.workbench.unavailable': '暂无数据',
  'pages.workbench.resourceUsage': '已使用 {used} / {total} {unit}',
  'pages.workbench.connectClusterDescription': '接入企业集群后查看资源用量',
  'pages.workbench.openMonitoring': '查看资源监控',
  'pages.workbench.guideTitle': '开始探索更多可能',
  'pages.workbench.guideDescription': '为团队找到合适的应用与能力。',
  'pages.workbench.guide.apps': '发现业务应用',
  'pages.workbench.guide.appsDescription': '浏览企业应用，扩展团队工具',
  'pages.workbench.footer': '企业数智化操作系统',
  'pages.workbench.deployments': '我的部署',
  'pages.workbench.deploymentsInCluster': '运行在企业集群中的服务',
  'pages.workbench.clusterNodes': '集群节点',
  'pages.workbench.readyNodes': '已就绪的节点',
  'pages.workbench.runningPods': '运行中容器组',
  'pages.workbench.podsInCluster': '集群内正在运行的 Pod',
  'pages.workbench.deploymentsPanel': '我的部署',
  'pages.workbench.deploymentsPanelDescription': '已部署到企业集群的应用与服务',
  'pages.workbench.allDeployments': '全部部署',
  'pages.workbench.noDeployments': '还没有任何部署',
  'pages.workbench.noDeploymentsDescription':
    '从部署模板一键部署或创建自定义镜像部署。',
  'pages.workbench.deploymentsError': '部署列表暂时不可用',
  'pages.workbench.openAppStore': '前往部署模板',
  'pages.workbench.guide.appStore': '部署云原生应用',
  'pages.workbench.guide.appStoreDescription':
    '一键部署数据库、运维面板与自定义容器',
};
